<template>
  <div class="footer">
    <div class="top-foot">
      <div class="container">
        <span>友情链接:</span>
        <div class="friend-link">
          <span v-for="(item, index) in friendList" :key="index">
            <a :href="item.url">{{ item.name }}</a>
          </span>
        </div>
        <!-- <div class="about-us">
          <span>
            <a href="#">关于我们</a>
          </span>
          <span>
            <a href="#">帮助中心</a>
          </span>
          <span>
            <a href="#">联系我们</a>
          </span>
          <span>
            <a href="#">免责声明</a>
          </span>
          <span>
            <a href="#">意见反馈</a>
          </span>
        </div> -->
      </div>
    </div>
    <div class="bot-foot">
      <p>
        <span>主办单位：安化县农业农村局</span>
        <span>地址：湖南省益阳市安化县东坪镇沿江路691号</span>
      </p>
      <p>
        <span>电话：0737-7223305</span>
        <span>邮箱：expert@ahnydsj.com</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      friendList: [
        { name: "安化产权交易中心", url: "https://anhuaxian.nongjiao.com/" },
        { name: "黑茶展销平台", url: "http://zx.ahnydsj.com/" },
        { name: "农技服务网", url: "http://nj.ahnydsj.com/home" },
        // { name: "黑茶全产业链大数据", url: "http://dp.ahnydsj.com/#/login" },
        // {
        //   name: "黑茶空天地监测平台",
        //   url: "http://68.79.21.114:8081/ah/login.html"
        // },
        // { name: "黑茶资源管理平台", url: "http://ht.ahnydsj.com/#/login" },
        // {
        //   name: "仓单质押管理系统",
        //   url: "http://220.170.152.160:58080/index.jsp"
        // },
        // { name: "质量检测系统", url: "http://zj.ahnydsj.com/#/login" },
        { name: "农交网", url: "https://www.nongjiao.com/" },
        { name: "土流网", url: "https://www.tuliu.com/" },
        { name: "天天学农", url: "https://old.ttxn.com/" },
        { name: "中国农业科技信息网", url: "http://www.cast.net.cn/" },
        { name: "中国农业信息网", url: "http://www.agri.cn/" },
        { name: "农业农村部官网", url: "http://www.moa.gov.cn/" },
        { name: "农视网", url: "https://www.ntv.cn/" },
        { name: "中国茶叶流通协会", url: "https://www.ctma.com.cn/" },
        { name: "茶叶科学", url: "http://www.tea-science.com/" },
        { name: "中国农业科学院", url: "https://www.caas.cn/" }
      ]
    };
  }
};
</script>

<style lang="less" scoped>
.footer {
  width: 100%;
  text-align: center;
  background-color: #333;
  margin-top: 20px;
  .top-foot {
    color: #b5b5b5;
    font-size: 14px;
    padding: 20px 0;
    border-bottom: 1px solid #5a5a5a;
    .container {
      display: flex;
      > span {
        display: inline-block;
        width: 80px;
        line-height: 24px;
      }
      .friend-link,
      .about-us {
        width: calc(100% - 80px);
        text-align: left;
        line-height: 24px;
        span {
          padding: 0 20px;
          display: inline-block;
          a {
            color: #b5b5b5;
            font-size: 14px;
          }
        }
      }
    }
  }
  .bot-foot {
    font-size: 12px;
    color: #b5b5b5;
    padding: 20px 0;
    p {
      padding: 5px 0;
      span {
        padding: 0 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue